import { FC } from 'react';
import { BsExclamationCircleFill } from 'react-icons/bs';
import { useQuoteContext } from '../../routes/Quotes/Quote/quoteContext';
import {
  getValidationsForFields,
  QUOTE_VALIDATION_COLOR,
} from '../../utils/quoteFieldValidations';
import { MBox, MFlex, MIcon, MText } from '../Monetize';

interface QuoteFieldValidationsProps {
  /**
   * Every field key the enclosing anchor hosts. A rule targeting more than one
   * of them still renders its message once.
   */
  fieldKeys: readonly string[];
}

export const QuoteFieldValidations: FC<QuoteFieldValidationsProps> = ({
  fieldKeys,
}) => {
  const {
    quoteData: { quote },
  } = useQuoteContext();

  const validations = getValidationsForFields(
    quote?.validations ?? [],
    fieldKeys,
  );

  if (validations.length === 0) {
    return null;
  }

  return (
    <MBox>
      {validations.map(({ ruleId, errorLevel, message }) => (
        <MFlex key={ruleId} alignItems="flex-start" mt="1">
          <MIcon
            as={BsExclamationCircleFill}
            color={QUOTE_VALIDATION_COLOR[errorLevel]}
            width={3.5}
            height={3.5}
            mt="0.5"
            mr="1.5"
            flexShrink={0}
          />
          <MText fontSize="sm" color={QUOTE_VALIDATION_COLOR[errorLevel]}>
            {message}
          </MText>
        </MFlex>
      ))}
    </MBox>
  );
};
